import { getPeriodDataset, listAvailablePeriods } from './periods/index.js';

const validGroup = (value, fallback = 1) => {
  const number = Number(value);
  return Number.isInteger(number) && number >= 1 && number <= 9 ? number : fallback;
};

export function defaultIrregularBlocks(period, profile) {
  const dataset = getPeriodDataset(period);
  if (!dataset) return {};
  return Object.fromEntries(dataset.blocks.map(({ number }) => {
    const syndrome = profile.rotation?.[number] || dataset.defaultRotations[profile.letter]?.[number] || Object.keys(dataset.syndromes)[0];
    const specialtyGroup = profile.clinics?.specialtyGroups?.[syndrome] ||
      (syndrome === 'reumato' ? profile.clinics?.aeReumato : syndrome === 'cirurgicas' ? profile.clinics?.aeCirurgicas : syndrome === 'obstetricia' ? profile.clinics?.aeObstetricia : null) || profile.sameGroup;
    return [number, { period, syndrome, letter: profile.letter, group: profile.groups?.[syndrome] || profile.sameGroup,
      fixedGroup: profile.clinics?.fixedGroup || profile.sameGroup, specialtyGroup }];
  }));
}

export function normalizeIrregularBlocks(input, period, profile) {
  const defaults = defaultIrregularBlocks(period, profile);
  return Object.fromEntries(Object.entries(defaults).map(([number, fallback]) => {
    const value = input?.[number] || {};
    const selectedPeriod = listAvailablePeriods().includes(Number(value.period)) ? Number(value.period) : fallback.period;
    const dataset = getPeriodDataset(selectedPeriod);
    const letter = ['A', 'B', 'C'].includes(value.letter) ? value.letter : fallback.letter;
    const syndrome = dataset.syndromes[value.syndrome] ? value.syndrome : dataset.defaultRotations[letter]?.[number] || Object.keys(dataset.syndromes)[0];
    const fixedMaximum = Math.max(1, ...Object.keys(dataset.fixedClinics?.[number]?.[letter] || {}).map(Number));
    const specialtyMaximum = Math.max(1, ...Object.keys(dataset.specialtyClinics?.[syndrome] || {}).map(Number));
    return [number, { period: selectedPeriod, letter, syndrome,
      group: Math.min(4, validGroup(value.group, fallback.group)),
      fixedGroup: Math.min(fixedMaximum, validGroup(value.fixedGroup, fallback.fixedGroup)),
      specialtyGroup: Math.min(specialtyMaximum, validGroup(value.specialtyGroup, fallback.specialtyGroup)) }];
  }));
}

export function profileForIrregularBlock(assignment, blockNumber, extraActivities = []) {
  const dataset = getPeriodDataset(assignment.period);
  const profile = { letter: assignment.letter, sameGroup: assignment.group, configured: true,
    rotation: { [blockNumber]: assignment.syndrome },
    groups: { [assignment.syndrome]: assignment.group },
    clinics: { fixedGroup: assignment.fixedGroup, specialtyGroups: { [assignment.syndrome]: assignment.specialtyGroup },
      aeReumato: assignment.specialtyGroup, aeCirurgicas: assignment.specialtyGroup, aeObstetricia: assignment.specialtyGroup },
    extraActivities };
  return { dataset, profile };
}
